import { useCallback, useContext } from 'react';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { insertContent } from '../utils/documentUtils';
import { getGlobalVars } from '../utils/globalVarUtil';
import { convertToPlaintextState } from '../utils/plaintextUtils';
import { EditorConfigContext } from '../contexts/EditorConfigContext';

/** Configuration for the Macros capability (predefined text insertion) */

export default function MacrosMenu({
  renderMacrosMenu
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const {
    usePlaintextMode,
    plaintextOptions
  } = getGlobalVars(useContext(EditorConfigContext));
  const insertMacroText = useCallback(content => {
    const newState = insertContent({
      htmlBody: content,
      editorState,
      from: editorState.selection.from,
      to: editorState.selection.to
    });
    setEditorState(usePlaintextMode ? convertToPlaintextState(newState, plaintextOptions) : newState);
  }, [editorState, setEditorState, usePlaintextMode, plaintextOptions]);
  return renderMacrosMenu(insertMacroText);
}
MacrosMenu.displayName = 'MacrosMenu';